import cn from 'classnames'
import React, { ComponentProps } from 'react'

type FolderXIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function FolderXIcon(props: FolderXIconProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('FolderXIcon', className)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect width="24" height="24" rx="4" fill="#EBF2FE" />
      <path
        d="M10.3334 11L13.6667 14.3333M13.6667 11L10.3334 14.3333M17.3334 17.3333C17.687 17.3333 18.0261 17.1929 18.2762 16.9428C18.5262 16.6928 18.6667 16.3536 18.6667 16V9.33333C18.6667 8.97971 18.5262 8.64057 18.2762 8.39052C18.0261 8.14048 17.687 8 17.3334 8H12.0667C11.8437 8.00219 11.6237 7.94841 11.4269 7.84359C11.2301 7.73877 11.0627 7.58625 10.94 7.4L10.4 6.6C10.2786 6.41565 10.1134 6.26432 9.91904 6.1596C9.72472 6.05488 9.50745 6.00004 9.28671 6H6.66671C6.31309 6 5.97395 6.14048 5.7239 6.39052C5.47385 6.64057 5.33337 6.97971 5.33337 7.33333V16C5.33337 16.3536 5.47385 16.6928 5.7239 16.9428C5.97395 17.1929 6.31309 17.3333 6.66671 17.3333H17.3334Z"
        stroke="#4489F9"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
